export const mediumFeatureKey = 'medium';

export type MediumModel = {
  id: number;
  name: string;
};
